<template>
  <div class="p-header">
    <div class="p-header-inner">
      <img
        class="p-header-logo"
        src="@/assets/images/logo-365-black.svg"
        alt=""
        @click="onClickLogo"
      />
      <div class="p-header-navigation">
        <div
          class="p-header-tab"
          :class="currentPage === '/home' ? 'p-header-tab-activated' : ''"
          @click="toPage('/home')"
        >
          首页
        </div>
        <div
          class="p-header-tab"
          :class="currentPage === '/price' ? 'p-header-tab-activated' : ''"
          @click="toPage('/price')"
        >
          定价
        </div>
        <div
          class="p-header-tab"
          :class="currentPage === '/case' ? 'p-header-tab-activated' : ''"
          @click="toPage('/case')"
        >
          客户案例
        </div>
        <a-dropdown
          :getPopupContainer="(triggerNode) => triggerNode.parentElement"
        >
          <div class="p-header-tab arrow-down" ref="authDropdown">
            <KdIcon
              icon="ArrowDownS"
              :size="16"
              fill="currentColor"
              margin="-8px 0px 0 3px"
              leftText="认证中心"
            ></KdIcon>
          </div>
          <a-menu class="a-menu" slot="overlay">
            <a-menu-item
              v-for="(item, index) in navAuthMenuItems"
              class="a-menu-item"
              :key="index"
            >
              <div class="a-menu-item-content" @click="clickAuthItem(item)">
                {{ item.title }}
              </div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div
          class="p-header-tab"
          :class="currentPage === '/help' ? 'p-header-tab-activated' : ''"
          @click="toPage('/help')"
        >
          帮助中心
        </div>
      </div>

      <div class="p-header-right">
        <div class="p-header-tab phone text">
          <KdIcon
            icon="EquipmentTelephone"
            :size="16"
            fill="currentColor"
            margin="-6px 10px 0 0"
            rightText="400-677-5005"
            textSize="14"
          ></KdIcon>
        </div>
        <div
          class="p-header-tab download"
          :class="currentPage === '/download' ? 'p-header-tab-activated' : ''"
          @click="toPage('/download')"
        >
          下载
        </div>
        <div
          class="p-header-tab login"
          v-if="loginLoading && !userInfo"
          @click="toLogin"
        >
          登录
        </div>

        <kd-dropdown
          v-else
          trigger="hover"
          placement="bottom-end"
          @select="onSelectAvatarMenu"
        >
          <div v-show="loginLoading && userInfo" class="user" slot="reference">
            <img
              v-show="loginLoading && userInfo"
              class="p-header-right-profile"
              :src="userInfo && userInfo.pic"
              alt=""
            />
          </div>
          <div v-if="userInfo" class="c-ch-avatar__menu-info">
            <img class="c-ch-avatar__menu-avatar" :src="userInfo.pic" alt="" />
            <div class="c-ch-avatar__menu-name">{{ userInfo.nickname }}</div>
          </div>
          <kd-menu-item
            v-for="(item, index) in avatarMenuList"
            :key="index"
            :index="item.type"
          >
            <div class="c-ch-avatar__menu-item">{{ item.name }}</div>
          </kd-menu-item>
        </kd-dropdown>
        <kd-button class="p-header-right-btn primary-btn" @click="handleBuy"
          >购买套餐</kd-button
        >
      </div>
    </div>
    <!-- <button @click="toSwitchAccount">切换</button> -->
  </div>
</template>

<script>
import Login from '@/common/login';
import { queryUserInfo, logout } from '@/common/request';
import { showMultiAccountGuide } from '@plus/epplatform/pkgs/multiAccount';
import { companyStart } from '@/common/epplatform';
import { common } from '@/common/constants/config';
import { getFromPage, getPageName } from '@/common/utils/index';
import infoCollect from '@/common/infoCollect';
import { navAuthMenuItems } from './config';
import { openBuyPage } from '@/common/utils/business';
import KdIcon from '@/components/KdIcon/index.vue';

export default {
  name: 'HomeView',
  data() {
    return {
      loginLoading: false,
      isPc: true,
      currentPage: this.$router.history.current.path,
      userProfile:
        'https://img.qwps.cn/1385942316?imageMogr2/thumbnail/180x180!&k=1665457890641338788',
      userInfo: null,
    };
  },
  components: { KdIcon },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.currentPage = val.path;
      },
      // 首次执行
      immediate: true,
    },
  },
  methods: {
    toLogin() {
      Login.login();
    },
    toSwitchAccount() {
      Login.switchAccount();
    },
    toPage(page) {
      var name = '';
      if (page === '/home') {
        name = 'head_home';
      } else if (page === '/price') {
        name = 'head_price';
      } else if (page === '/help') {
        name = 'head_help';
      } else if (page === '/case') {
        name = 'head_customer_case';
      } else if (page === '/download') {
        name = 'head_down_load';
      }
      infoCollect.dwCollectData('button_click', name, 'PC', {
        page_name: getPageName(),
        from_item: getFromPage(),
      });

      var fromPage = '';
      if (location.pathname.includes('/home')) {
        fromPage = 'edu_web_home_page';
      } else if (location.pathname.includes('/price')) {
        fromPage = 'edu_web_price_page';
      } else if (location.pathname.includes('/help')) {
        fromPage = 'edu_web_help_page';
      } else if (location.pathname.includes('/case')) {
        fromPage = 'edu_web_customer_case_page';
      } else if (location.pathname.includes('/download')) {
        fromPage = 'load_page';
      }

      this.currentPage = page;
      this.$router.push(`${page}?fromPage=${fromPage}`);
    },
    contactSales() {
      infoCollect.dwCollectData('button_click', 'head_contact_sales', 'PC', {
        page_name: getPageName(),
        from_item: getFromPage(),
      });
      window.open(common.contactSales);
    },
    async init() {
      try {
        this.userInfo = await queryUserInfo();
      } finally {
        this.loginLoading = true;
      }
    },
    onClickLogo() {
      this.$router.push('/home');
    },

    onSelectAvatarMenu(type) {
      const config = this.avatarMenuList.find((item) => item.type === type);
      this.handleAvatarMunuSelected(config);
    },

    async handleAvatarMunuSelected(config) {
      const { type } = config || {};

      switch (type) {
        case 'KDOCS':
          config?.url && window.open(config?.url, '_blank');
          break;

        case 'CREATE_COMPANY':
          if (this.userInfo) {
            companyStart(this.userInfo.companyid, this.userInfo.userid);
          }
          break;

        case 'SWITCH_ACCOUNT':
          this.toSwitchAccount();
          break;

        case 'QA':
          config?.url && window.open(config?.url, '_blank');
          break;

        case 'LOGOUT':
          try {
            await logout();
            window.location.reload();
          } catch (e) {
            console.error('退出登陆异常:', e);
          }
          break;
      }
    },

    toSwitchAccount() {
      showMultiAccountGuide({
        title: '请选择账号',
        closed: true,
        selectText: '切换',
        onSwitchSuccess: () => {
          window.location.reload();
        },
      });
    },
    clickAuthItem(config) {
      const { link } = config || {};
      window.open(link, '_blank');
    },
    handleBuy() {
      infoCollect.dwCollectData('button_click', 'head_buy', 'PC', {
        page_name: getPageName(),
        from_item: getFromPage(),
      });
      openBuyPage('_blank', { serviceVal: 'wps365_edu_application' });
    },
  },
  created() {
    this.navAuthMenuItems = navAuthMenuItems;
    this.avatarMenuList = [
      {
        name: '金山文档｜WPS云文档',
        type: 'KDOCS',
        url: 'https://www.kdocs.cn/latest',
      },
      {
        name: '创建新机构',
        type: 'CREATE_COMPANY',
      },
      {
        name: '切换账号',
        type: 'SWITCH_ACCOUNT',
      },
      {
        name: '帮助与反馈',
        type: 'QA',
        url: 'https://plus.wps.cn/blog/service',
      },
      {
        name: '退出',
        type: 'LOGOUT',
      },
    ];
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.p-header {
  width: 100%;
  height: 64px;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  opacity: 1;
  transition:
    opacity 0.3s,
    transform 0.3s;
  box-shadow:
    rgba(116, 134, 163, 0.04) 0px 1px 2px 0px,
    rgba(116, 134, 163, 0.1) 0px 2px 8px 0px;
  &.hide {
    opacity: 0;
  }

  &-inner {
    display: flex;
    width: 100%;
    min-width: $width-s;
    margin: 0 auto;
    max-width: 1264px;
    padding: 0 32px;
    box-sizing: border-box;
    position: relative;
    align-items: center;
  }
  &-logo {
    width: 134px;
    height: 28px;
    // margin-top: 16px;
    margin-right: 36px;
    cursor: pointer;
  }

  &-navigation {
    display: flex;
  }

  &-right {
    position: absolute;
    right: 32px;
    // line-height: 70px;
    display: flex;
    align-items: center;
    .user {
      // margin-top: 16px;
      margin-left: 12px;
      margin-right: 24px;
    }
    &-btn {
      width: 88px;
      height: 32px;
      font-size: 14px;
      padding: 0;
      // margin-top: 17px;
    }

    &-profile {
      width: 32px;
      height: 32px;
      border: 1px solid #ffffff;
      border-radius: 16px;
      cursor: pointer;
      position: relative;
    }
  }

  &-contact {
    display: flex;
    margin-right: 16px;
    line-height: 64px;
  }

  &-phone-icon {
    width: 24px;
    height: 24px;
    margin-left: 10px;
    margin-right: 16px;
    margin-top: 4px;
  }

  .arrow-down :deep(.target) {
    margin-right: 0;
    margin-left: 4px;
  }
  &-phone {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: rgba(13, 13, 13, 0.9);
  }

  &-time {
    font-size: 12px;
    line-height: 12px;
    margin-top: 4px;
    color: rgba(13, 13, 13, 0.66);
  }
}

.p-header,
.p-right {
  &-tab {
    font-weight: 400;
    height: 30px;
    line-height: 30px;
    letter-spacing: 0;
    color: #000000;
    padding: 0 12px;
    border-radius: 4px;
    // margin-top: 17px;
    font-size: var(--kd-font-size-base, 14px);
    color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));

    &.ant-dropdown-trigger label {
      cursor: pointer;
    }

    &:not(.text) {
      margin-right: 12px;
      cursor: pointer;
      &.ant-dropdown-open {
        background: var(--kd-color-state-hover, rgba(13, 13, 13, 0.06));
      }

      &:hover {
        position: relative;
        background: var(--kd-color-state-hover, rgba(13, 13, 13, 0.06));
      }
    }
  }

  &-tab-activated {
    position: relative;
    background: var(--kd-color-state-hover, rgba(13, 13, 13, 0.06));
  }
}

@media (max-width: 1000px) {
  .download,
  .phone {
    display: none;
  }
}
@media (max-width: 850px) {
  .p-header-navigation {
    display: none;
  }
}
// @include responsiveV2($width-m) {
//   .p-header-navigation {
//     display: none;
//   }
// }

// @include responsiveV2($width-m) {
//   .download,
//   .phone {
//     display: none;
//   }
// }

.c-ch-avatar__menu {
  &-info {
    width: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    overflow: hidden;
  }

  &-avatar {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-bottom: 6px;
  }

  &-name {
    width: 100%;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
}
</style>

<style lang="scss">
.kdv-dropdown.kdv-popper {
  padding: 12px;
  .kdv-menu.kdv-dropdown__list {
    padding: 0;
  }
}
.c-ch-avatar__menu-item {
  width: 240px;
  height: 34px;
  line-height: 34px !important;
  font-size: 14px !important;
  text-align: center !important;
}

.p-header {
  & .a-menu {
    padding: 12px;
    border-radius: 8px;
    border: 1px solid var(---kd-color-line-regular, rgba(13, 13, 13, 0.12));
    box-shadow: 0px 12px 32px 0px rgba(13, 13, 13, 0.08);
  }

  & .a-menu-item {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & .a-menu-item:hover {
    background: none;
  }

  & .a-menu-item-content {
    border-radius: 6px;
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
    font-size: 14px;
    margin-top: 4px;
    color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));

    &:hover {
      background: var(--kd-color-state-hover, rgba(13, 13, 13, 0.06));
    }
  }
}
</style>
